const config = {
  style: {
    colorScheme: 'light',
    themeColor: '#090a0b',
    primaryColor: 'default'
  },
  logLevel: 'ALL'
}

export default config
